export const cardWidth = 257;
const cardHeight = 416;
export const cardRatio = cardWidth / cardHeight;
